webpackJsonpCfHeader([5],{

/***/ 144:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(16);
	var utils_1 = __webpack_require__(75);
	var links_1 = __webpack_require__(145);
	;
	;
	;
	;
	var styles = __webpack_require__(419);
	
	var DropdownMenu = function (_React$Component) {
	    _inherits(DropdownMenu, _React$Component);
	
	    function DropdownMenu(props) {
	        _classCallCheck(this, DropdownMenu);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.DELAY = 300;
	        _this.triangle = {};
	        _this.onLinkClick = function (_ref) {
	            var event = _ref.event,
	                onClick = _ref.onClick,
	                url = _ref.url,
	                target = _ref.target;
	
	            event.preventDefault();
	            if (onClick) {
	                onClick();
	            }
	            target === '_blank' ? window.open(url) : location.replace(url);
	        };
	        _this.state = {
	            parentOver: false
	        };
	        _this.mouseMoveDocument = _this.mouseMoveDocument.bind(_this);
	        return _this;
	    }
	
	    DropdownMenu.prototype.componentWillMount = function componentWillMount() {
	        var _this2 = this;
	
	        if (this.props.alwaysOpened) {
	            return;
	        }
	        this.parentElementRect = this.props.parentElement.getBoundingClientRect();
	        this.props.parentElement.addEventListener('mouseenter', function (event) {
	            _this2.setState({
	                parentOver: true
	            }, function () {
	                _this2.createTriangle();
	                document.addEventListener('mousemove', _this2.mouseMoveDocument);
	            });
	        });
	        this.props.parentElement.addEventListener('mouseout', function (event) {
	            _this2.setState({
	                parentOver: false
	            }, function () {
	                document.removeEventListener('mousemove', _this2.mouseMoveDocument);
	                setTimeout(function () {
	                    return !_this2.state.parentOver && _this2.setState({ mouseInTriangle: false });
	                }, _this2.DELAY);
	            });
	        });
	    };
	
	    DropdownMenu.prototype.render = function render() {
	        var _this3 = this;
	
	        if (this.props.alwaysOpened) {
	            return this.renderAlwaysOpened();
	        }
	        return React.createElement(
	            "div",
	            { className: styles['container'] + " " + styles['container--scale'] + " " + ((this.state.parentOver || this.state.mouseInTriangle || this.state.dropdownOver) && styles['container--scale_over']) + " cf_header-bottom_menu_item-dropdown", ref: function ref(el) {
	                    return _this3.containerElement = el;
	                }, onMouseEnter: function onMouseEnter(e) {
	                    return _this3.dropdownMouseEnter(e);
	                }, onMouseLeave: function onMouseLeave(e) {
	                    return _this3.dropdownMouseOut(e);
	                } },
	            _jsx("div", {
	                className: "cg-container-fluid-xs"
	            }, void 0, _jsx("div", {
	                className: "cg-row"
	            }, void 0, _jsx("div", {
	                className: "cg-skip-3 cg-col-21"
	            }, void 0, _jsx("div", {
	                className: styles['list']
	            }, void 0, this.renderLinks()))))
	        );
	    };
	
	    DropdownMenu.prototype.renderAlwaysOpened = function renderAlwaysOpened() {
	        var _this4 = this;
	
	        return React.createElement(
	            "div",
	            { className: styles['container'] + " " + styles['container--scale'] + " " + styles['container--scale_over'] + "\n        " + styles['container--always_opened'] + " " + (this.props.hideShadow && styles['container--no_shadow']), ref: function ref(el) {
	                    return _this4.containerElement = el;
	                } },
	            _jsx("div", {
	                className: "cg-container-fluid-xs"
	            }, void 0, _jsx("div", {
	                className: "cg-row"
	            }, void 0, _jsx("div", {
	                className: "cg-skip-3 cg-col-21"
	            }, void 0, _jsx("div", {
	                className: styles['list']
	            }, void 0, this.renderLinks()))))
	        );
	    };
	
	    DropdownMenu.prototype.renderLinks = function renderLinks() {
	        var _this5 = this;
	
	        return this.props.links.map(function (_ref2, index) {
	            var _onClick = _ref2.onClick,
	                target = _ref2.target,
	                text = _ref2.text,
	                url = _ref2.url;
	            return _jsx("div", {
	                className: styles['item']
	            }, "link-" + index, React.createElement(
	                "a",
	                _extends({ href: url }, utils_1.mergeStyles(text === links_1.DOM_RF_TITLE && styles['domrf-promo'], styles['link']), { onClick: function onClick(event) {
	                        return _this5.onLinkClick({
	                            event: event,
	                            onClick: _onClick,
	                            target: target,
	                            url: url
	                        });
	                    }, target: target || '_self' }),
	                text
	            ));
	        });
	    };
	
	    DropdownMenu.prototype.dropdownMouseEnter = function dropdownMouseEnter(e) {
	        this.setState({
	            dropdownOver: true
	        });
	    };
	
	    DropdownMenu.prototype.dropdownMouseOut = function dropdownMouseOut(e) {
	        this.setState({
	            dropdownOver: false
	        });
	    };
	
	    DropdownMenu.prototype.mouseMoveDocument = function mouseMoveDocument(e) {
	        if (this.checkMouseInTriangle({ x: e.pageX, y: e.pageY })) {
	            this.setState({
	                mouseInTriangle: true
	            });
	        } else {
	            this.setState({
	                mouseInTriangle: false
	            });
	        }
	    };
	
	    DropdownMenu.prototype.createTriangle = function createTriangle() {
	        var containerRect = this.containerElement.getBoundingClientRect();
	        var parentRect = this.props.parentElement.getBoundingClientRect();
	        this.triangle.top = {
	            x: parentRect.left + document.body.scrollLeft + parentRect.width / 2,
	            y: parentRect.top + document.body.scrollTop + parentRect.height / 2
	        };
	        this.triangle.left = {
	            x: containerRect.left + document.body.scrollLeft,
	            y: containerRect.top + document.body.scrollTop
	        };
	        this.triangle.right = {
	            x: this.triangle.top.x + containerRect.width,
	            y: this.triangle.top.y
	        };
	    };
	
	    DropdownMenu.prototype.checkMouseInTriangle = function checkMouseInTriangle(coords) {
	        var _triangle = this.triangle,
	            left = _triangle.left,
	            top = _triangle.top,
	            right = _triangle.right;
	
	        var a = (left.x - coords.x) * (top.y - left.y) - (top.x - left.x) * (left.y - coords.y);
	        var b = (top.x - coords.x) * (right.y - top.y) - (right.x - top.x) * (top.y - coords.y);
	        var c = (right.x - coords.x) * (left.y - right.y) - (left.x - right.x) * (right.y - coords.y);
	        return a >= 0 && b >= 0 && c >= 0 || a <= 0 && b <= 0 && c <= 0;
	    };
	
	    return DropdownMenu;
	}(React.Component);
	
	exports.default = DropdownMenu;

/***/ },

/***/ 419:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"QEBAyrYnmgseOxHY","container--scale":"q5XGKNmfgaeiSjZQ","container--scale_over":"_3R39iaL0Cw-T-F2v","container--always_opened":"_3JcQdWrBTtWTlU0_","container--no_shadow":"VtVQ4YnI58SA3tJ1","list":"_3njfj2ZwsHu6gfq6","item":"HQtt_F6F02NMZvrL","link":"_1HtR19DTeV_PyjHh","domrf-promo":"_-iAWcauWNmqD4rXq"};

/***/ }

});


// WEBPACK FOOTER //
// header-031894c20ab04c0e0f08.js